import { css } from 'styled-components'

export const ListReset = css`
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
`

export const LinkReset = css`
  &:link {
    color: inherit;
    text-decoration: none;
  }
  &:visited {
    color: inherit;
  }
`

export const ButtonReset = css`
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  background: inherit;
  cursor: pointer;
  color: currentColor;
`

export const HeadingReset = css`
  margin-top: 0;
  margin-bottom: 0;
`

/**
 * https://ghinda.net/article/mimic-native-focus-css/
 *
 * TODO: Remove this once we've gotten rid of some of the legacy css (it removes outline from all focus states)
 */
export const Refocus = css`
  outline-width: 2px;
  outline-style: solid;
  outline-color: Highlight;

  /* WebKit gets its native focus styles.
  */
  @media (-webkit-min-device-pixel-ratio: 0) {
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
  }

  @supports (outline-color: -webkit-focus-ring-color) {
    outline-width: 5px;
  }
`
